import React from 'react';
import PropTypes from 'prop-types';

const ModalSubheader = ({ children }) => (
  <div className="modal-subheader">
    {children}
  </div>
);

ModalSubheader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default ModalSubheader;
